import type { FeatureItem } from "../content/landingContent.js";
import { useTranslation } from "../i18n/useTranslation.js";
import ProcessIcon from "./ProcessIcon.js";

interface FeatureGridProps {
  items: FeatureItem[];
}

const FeatureGrid = ({ items }: FeatureGridProps) => {
  const { t } = useTranslation();
  return (
    <div className="landing-feature-grid">
      {items.map((item) => (
        <article className="landing-feature-card" key={item.titleKey}>
          <span aria-hidden="true">{item.index}</span>
          {item.icon && <ProcessIcon icon={item.icon} />}
          <h3>{t(item.titleKey)}</h3>
          <p>{t(item.bodyKey)}</p>
        </article>
      ))}
    </div>
  );
};

export default FeatureGrid;
